export default "__VITE_ASSET__Dp8GvRXq__"